
import { ITagsView } from '@/types/app';
import { defineComponent } from 'vue';
import { tagsView } from '@/store';
import utils from '@/utils';

interface IState {
  visible: boolean;
  top: number;
  left: number;
  selectedTag: ITagsView;
}

export default defineComponent({
  name: 'TagsView',
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {} as ITagsView,
    } as IState;
  },
  computed: {
    views() {
      return tagsView.views;
    },
  },
  watch: {
    $route() {
      this.addTags();
      this.moveToCurrentTag();
    },

    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    },
  },
  mounted() {
    this.addTags();
  },
  methods: {
    isActive(route: ITagsView): boolean {
      return utils.trim(route.path, '/') === utils.trim(this.$route.path, '/');
    },

    addTags() {
      const { name } = this.$route;
      if (name) {
        tagsView.addView(this.$route);
      }
      return false;
    },

    moveToCurrentTag() {
      this.$nextTick(() => {
        for (const tag of this.views) {
          if (tag.path === this.$route.path) {
            // this.$refs.scrollPane.moveToTarget(tag)
            // when query is different then update

            if (tag.fullPath !== this.$route.fullPath) {
              tagsView.updateView(this.$route);
            }
            break;
          }
        }
      });
    },

    refreshSelectedTag(view: ITagsView) {
      tagsView.delView(view).then(() => {
        const { fullPath } = view;
        this.$nextTick(() => {
          this.$router
            .replace({
              path: `/redirect${fullPath}`,
            })
            .catch((err: Error) => {
              console.warn(err);
            });
        });
      });
    },

    closeSelectedTag(view: ITagsView) {
      tagsView.delView(view).then((views) => {
        if (this.isActive(view)) {
          this.toLastView(views);
        }
      });
    },

    closeOthersTags() {
      if (this.selectedTag.fullPath !== this.$route.path && this.selectedTag.fullPath !== undefined) {
        this.$router.push(this.selectedTag.fullPath).catch((err: Error) => {
          console.warn(err);
        });
      }
      tagsView.delOthersViews(this.selectedTag);
      this.moveToCurrentTag();
    },

    closeAllTags() {
      tagsView.delAllViews();
      this.toLastView(tagsView.views);
    },

    toLastView(views: ITagsView[]) {
      if (!views) return;
      const latestView = views.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath || '/');
      } else {
        this.$router.push('/');
      }
    },

    openMenu(tag: ITagsView, e: MouseEvent) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const { offsetWidth } = this.$el; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right

      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY - 45;
      this.visible = true;
      this.selectedTag = tag;
    },

    closeMenu() {
      this.visible = false;
    },
  },
});
